import { render } from "./DropdownBox.vue?vue&type=template&id=b613e24a&scoped=true"
import script from "./DropdownBox.vue?vue&type=script&lang=js"
export * from "./DropdownBox.vue?vue&type=script&lang=js"

import "./DropdownBox.vue?vue&type=style&index=0&id=b613e24a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b613e24a"]])

export default __exports__